import { useLanguage } from '../contexts/LanguageContext';
import { usePosts } from '../hooks/usePosts';
import RichText from '../components/RichText';

const AboutPage = () => {
  const { locale } = useLanguage();
  const { posts, loading } = usePosts();

  if (loading) {
    return <div className="about-page" />;
  }

  const aboutPost = posts.find(
    (p) => p.title.en.toLowerCase() === 'about'
  );

  if (!aboutPost) {
    return <div className="about-page" />;
  }

  return (
    <div className="about-page">
      <article className="stories-content">
        <header className="stories-content__header">
          <h1>{aboutPost.title[locale]}</h1>
        </header>
        <RichText
          content={aboutPost.content[locale]}
          className="stories-content__body"
        />
      </article>
    </div>
  );
};

export default AboutPage;
